/**
 *  @fileOverview Location toggle module, provides functionality to toggle between domestic and international content.
 *
 *  @author       Chris Hill
 *
 */

function AudienceModule () {
  /**
   * @description Initialises location toggle instances.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.init = function () {
    /**
     * Set body to domestic to show domestic content
     */
    document.querySelector('body').classList.add('audience--domestic')

    /**
     * Get all audience sections
     */
    var nodes = document.querySelectorAll('.contextToggle')

    /**
     * Check for saved option and apply to all inputs
     */
    let store = window.localStorage
    if (store.getItem('ecu-audience') !== null) {
      /**
       * Loop through all inputs and set them to the selected value eg make them all the same
       */
      let t = document.querySelectorAll('.contextToggle__input')
      t.forEach((el, i) => {
        if (store.getItem('ecu-audience') === 'Domestic') {
          el.checked = false
          document.querySelector('body').classList.remove('audience--international')
          document.querySelector('body').classList.add('audience--domestic')
        } else {
          el.checked = true
          document.querySelector('body').classList.remove('audience--domestic')
          document.querySelector('body').classList.add('audience--international')
        }
      })
    }

    /**
     * Loop through and add event to all checkboxes
     */
    nodes.forEach((element, index) => {
      let toggle = element.querySelector('.contextToggle__input')

      toggle.addEventListener('click', function () {
        /**
         * Toggle the body class between domestic and international
         */
        if (toggle.checked) {
          document.querySelector('body').classList.remove('audience--domestic')
          document.querySelector('body').classList.add('audience--international')
          store.setItem('ecu-audience', 'International')
        } else {
          document.querySelector('body').classList.remove('audience--international')
          document.querySelector('body').classList.add('audience--domestic')
          store.setItem('ecu-audience', 'Domestic')
        }

        /**
         * Loop through all inputs and set them to the selected value eg make them all the same
         */
        let t = document.querySelectorAll('.contextToggle__input')
        t.forEach((el, i) => {
          el.checked = toggle.checked
        })
      })
    })
  }
}

module.exports = AudienceModule
